export default __webpack_public_path__ + "static/media/react-logo-transparent.d808bd59.svg";